import { QueryClient } from '@tanstack/react-query';
import { isRefusal } from '../lib/httpError';

/**
 * Ask again once, a second later, unless the server ANSWERED: a 404 or a 403
 * is its reply, not a fault, and the second ask gets the same reply a second
 * later. Pages read those replies as answers (a non-member's collection opens
 * read-only, a gone study says so), and the old blanket `retry: 1` held each
 * of them on a blank page for that second first (prod, 2026-10-01: 404, 1 s,
 * 404, then the page). What counts as an answer is lib/httpError.ts.
 */
export function retryUnlessAnswered(failures: number, err: unknown): boolean {
  return failures < 1 && !isRefusal(err);
}

// DICOM objects are immutable once stored, so cached query results stay valid for
// a long time — we keep them fresh for the session and avoid noisy refetches.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: retryUnlessAnswered,
    },
  },
});
